import ErrorBoundary from '@components/ErrorBoundary';
import { Box, Card, CardContent, CardHeader, Grid, List, Typography } from '@mui/material';
import { convertMarkdownToHTMLString } from '@utils/convertMarkdownToHtml';
import Markdown from 'react-markdown';
import { AddToReportButton } from './AddToReportButton';

export const OverallAnalysis = ({ data }) => {
  return (
    <>
      <Grid container spacing={2}>
        <Grid item xs={12}>
          {data?.map((item, index) => {
            const markdownHtml = convertMarkdownToHTMLString(item);
            return (
              <Box key={index} sx={{ position: 'relative' }}>
                <Box sx={{ position: 'absolute', right: -40, zIndex: 9 }}>
                  <ErrorBoundary FallbackComponent={() => null}>
                    <AddToReportButton name={'Untitled Section'} description={markdownHtml} />
                  </ErrorBoundary>
                </Box>
                <Card
                  variant="outlined"
                  sx={{ mx: 'auto', p: 0, mb: 2, position: 'relative' }}
                  key={index}
                >
                  <CardContent
                    sx={{
                      p: '0 16px !important',
                      color: '#000 !important',
                      '& p': {
                        margin: '0px',
                        color: '#000 !important',
                      },
                      '& h2': { margin: '15px 0px 0px 0px', color: '#7d5ae8' },
                      '& h3': { margin: '15px 0px 0px 0px' },
                      '& ul': { marginTop: '0px', listStyleType: 'disc' },
                    }}
                  >
                    <List>
                      <Markdown key={index}>{item}</Markdown>
                    </List>
                  </CardContent>
                </Card>
              </Box>
            );
          })}
        </Grid>
      </Grid>
    </>
  );
};

export const OverallAnalysisNotFound = ({ text }) => {
  return (
    <div style={{ padding: '10px', margin: '20px' }}>
      <Card variant="outlined">
        <CardHeader
          title={
            <Typography variant="h6" fontWeight="bold">
              {text} Overall Result
            </Typography>
          }
          sx={{ pb: 0 }}
        />
        <CardContent>
          <Typography variant="body2">No data available for this {text}</Typography>
        </CardContent>
      </Card>
    </div>
  );
};
